export default "__VITE_ASSET__BwM9Mbhu__"